import { FETCH_ASSIGNED_CHILDREN_SUCCESS, FETCH_TEACHERS_SUCCESS } from '../actions/teacherActions';


const initialState = {
  children: [],
  teachersList: [],
};

const teacherReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ASSIGNED_CHILDREN_SUCCESS:
      return { ...state, children: action.payload };
    case FETCH_TEACHERS_SUCCESS:
      return {
        ...state,
        teachersList: action.payload,
      };
    default:
      return state;
  }
};

export default teacherReducer;
